module.exports = __webpack_public_path__ + "img/cert.085a6e53.svg";